import MapTrackingProvider from './MapTrackingProvider';

export default MapTrackingProvider;
